import { invokeApig } from '../../libs/awsLib';

const getAdmissionData = (entityId, admissionId) => {
  return invokeApig({
    path:
      `/entity/${entityId}/admission/${admissionId}/event-bulk?types=` +
      'patient-demographics,patient,reviews,assigned-user,escalation-users,care-levels',
  });
};

const getReviews = (entityId, admissionId) => {
  return invokeApig({
    path: `/entity/${entityId}/admission/${admissionId}/event-bulk?types=reviews`,
  });
};

const saveRecentlyViewedEncounter = async (encounterId, setError) => {
  try {
    const results = await invokeApig({
      path: `/recentlyViewedEncounters`,
      method: 'POST',
      body: {
        encounterId: encounterId,
      },
    });
    if (!results.success) {
      return setError((prev) => [
        ...prev,
        'An error occurred. Unable to save encounter to recently viewed table',
      ]);
    }

    return results;
  } catch (error) {
    console.error(error);
  }
};

const getSLADueDate = (entityId, admissionId) => {
  return invokeApig({
    path: `/entity/${entityId}/admission/${admissionId}/sla-due-date`,
  });
};

export {
  getAdmissionData,
  getReviews,
  getSLADueDate,
  saveRecentlyViewedEncounter,
};
